import { useEffect, useMemo, type ReactNode } from 'react';
import { ActivityIndicator, View } from 'react-native';
import { useLocation } from 'react-router-dom';
import { resolveHostRedirect } from '../lib/constants/hostRouting';

type HostRoutingGateProps = {
  children: ReactNode;
};

export function HostRoutingGate({ children }: HostRoutingGateProps) {
  const location = useLocation();
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const redirectTo = useMemo(
    () => resolveHostRedirect(hostname, location.pathname, location.search, location.hash),
    [hostname, location.hash, location.pathname, location.search]
  );

  useEffect(() => {
    if (!redirectTo || typeof window === 'undefined') return;
    if (redirectTo === window.location.href) return;
    window.location.replace(redirectTo);
  }, [redirectTo]);

  if (redirectTo) {
    return (
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#F5F6F8',
        }}
      >
        <ActivityIndicator size="large" color="#A20000" />
      </View>
    );
  }

  return <>{children}</>;
}
